import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { UserRole } from '@/models/features/user.models'

export type ReservationNote = {
  createdAt: number
  id: number
  noteBody: string
  reservationId: string
  timeBlockId: string | null
  title: string
  updatedAt: number
  createdBy: {
    id: number
    avatar: string | null
    firstName: string
    lastName: string
    email: string
    role: UserRole
  }
}

export const RESERVATION_NOTES_QUERY_KEY = 'useGetReservationNotes'

export const getReservationNotesQueryKey = (reservationId: string) => [
  RESERVATION_NOTES_QUERY_KEY,
  reservationId,
]

const getReservationNotes = async (reservationId: string) => {
  const response = await authAPI.get<ReservationNote[]>(`/reservation/${reservationId}/notes`)

  return response.data
}

export const useGetReservationNotes = (reservationId: string) => {
  return useQuery({
    enabled: !!reservationId,
    queryFn: () => getReservationNotes(reservationId),
    queryKey: getReservationNotesQueryKey(reservationId),
  })
}
